import { Fragment } from "react";
import {
  PatternSymbolColor,
  TemplateNodeType,
} from "../../../__generated__/gql/graphql";
import Symbol from "../../../ui/Symbol/Symbol";
import styles from "./Pattern.module.scss";
import classNames from "classnames";
import isSymbolColor from "../../../ui/Symbol/is-symbol-color";

function PatternName({
  className,
  templateNodes,
  symbols,
}: {
  className?: string;
  templateNodes: { type: TemplateNodeType; value: string }[];
  symbols: {
    name: string;
    color: PatternSymbolColor;
    values?: string[] | null;
  }[];
}) {
  return (
    <span className={classNames(styles.pattern, className)}>
      {templateNodes.map((node, index) => {
        if (node.type === TemplateNodeType.Text) {
          return <Fragment key={index}>{node.value}</Fragment>;
        }

        const symbol = symbols.find((s) => s.name === node.value);

        if (!symbol) {
          return null;
        }

        const color = symbol.color.toLowerCase();

        return (
          <Symbol
            className={styles.symbol}
            color={isSymbolColor(color) ? color : undefined}
            count={symbol.values?.length}
            key={node.value}
            name={node.value}
            size="medium"
          />
        );
      })}
    </span>
  );
}

export default PatternName;
